import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { createSearchPOIsFromAddressStore, createSearchPoisStore, getPoisStore } from '$routes/(map)/loadPois';

export const load = (async (event) => {
	const { searchParams } = await event.parent();
	const { page } = searchParams;

	const poisStore = await getPoisStore({
		event,
		searchPOIStore: createSearchPoisStore(),
		searchPOIFromAddressStore: createSearchPOIsFromAddressStore(),
	});

	return {
		page,
		poisStore,
		mobileTopButtons: ['search'],
		pagename: routesPagename.POI_FILTER,
	};
}) satisfies PageLoad;
